import ShipmentInfo from "./ShipmentInfo";

export default ShipmentInfo;
